module.exports = __webpack_public_path__ + "static/media/react_orange.ae385274.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/react_orange.png
// module id = 693
// module chunks = 0